const { is } = require("immutable");

(function($) {
  let menu_open_body_class = "mobile-menu-open";
  let menu_width = 1024;

  $(document).ready(function () {
    $(".newsletter-subscribe-form").on(
      "submit",
      coifferieSubscribeToNewsletter
    );
    $(".scroll-top-btn").on("click", coifferieScrollToTop);
    $(".mobile-menu-btn").on("click", coifferieOpenMobileMenu);
    $(".close-menu-btn, body").on("click", coifferieCloseMobileMenu);
    $(".anchor-navigation").on("click", coifferieAnchorNavigation);
    $(window).on("scroll", coifferieOnScrollActions);
    $(".main-header-menu li.menu-item-has-children > a").on(
      "click",
      coifferieHeaderOpenSubMenu
    );
    //Prevents the click in the menu and the open button from closing the menu and being considered as a click on the body
    $(".main-header-menu, .mobile-menu-btn").on("click", function (event) {
      event.stopPropagation();
    });

    if ($(".btn-video").length > 0) {
      $(".btn-video").magnificPopup({
        type: "iframe",
      });
    }

    if ($("#promoButton").length > 0) {
      $("#promoButton").on("click", copyPromoCode);
      $('#promoButton').on('mousedown', function(e) {
        e.preventDefault(); // Empêche la sélection de texte
    });
    }

    if($('.popup-overlay').length > 0) {
      // Vérifier si le popup a déjà été affiché aujourd'hui
      var lastPopupDate = localStorage.getItem('popupDate');
      var today = new Date().toLocaleDateString();

      // Si le popup n'a pas été affiché aujourd'hui, le montrer
      if (lastPopupDate !== today) {
          setTimeout(function() {
                    showPopup(); // Afficher le popup après 10 secondes
                    localStorage.setItem('popupDate', today); // Enregistrer la date d'affichage
          }, 10000); // 10 000 millisecondes = 10 secondes
      }

      // Cacher le popup au clic sur le bouton "Fermer"
      $('#closePopup').click(function() {
        hidePopup();
      });
    }
  });

  /**
   * Function called on the scroll to top button. Used to scroll at the top of the page.
   * @param {*} e
   */
  function coifferieScrollToTop(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: "0px" }, 1000);
  }

  /**
   * Function called everytime a scroll happens on the page. Used to handle all actions that need to happen on scroll.
   * @param {*} e
   */
  function coifferieOnScrollActions(e) {
    let scroll_top_value = $(window).scrollTop();

    //Display or hide the scroll to top button
    if (scroll_top_value > 300) {
      $(".scroll-top-btn").removeClass("opacity-0");
    } else {
      $(".scroll-top-btn").addClass("opacity-0");
    }

    //Hide the header tagline
    if (scroll_top_value > 1) {
      $(".tagline").slideUp(250);
    } else {
      $(".tagline").slideDown(250);
    }
  }

  function coifferieOpenMobileMenu(e) {
    console.log("test");
    e.preventDefault();
    $("body").addClass(menu_open_body_class);
  }

  function coifferieCloseMobileMenu(e) {
    if ($("body").hasClass(menu_open_body_class)) {
      e.preventDefault();
      $("body").removeClass(menu_open_body_class);
    }
  }

  /**
   * Called on anchor links with the "anchor-navigation" class. Makes an inner page navigation based ton the links href
   * @param {*} e
   */
  function coifferieAnchorNavigation(e) {
    e.preventDefault();
    let target_id = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target_id).offset().top - $(".main-header").height() - 10,
      },
      1000
    );
  }

  function coifferieHeaderOpenSubMenu(e) {
    if (window.innerWidth < menu_width) {
      $(this).parent().toggleClass("sub-menu-opened");
      $(this).parent().find(".sub-menu").slideToggle();
      e.preventDefault();
    }
  }

  /**
   *
   * Function called on the newsletter subscription form submit action. Used to call via AJAX our newsletter subscription function.
   * @returns
   */
  function coifferieSubscribeToNewsletter(e) {
    var $form = $(this);
    var email = $form.find('input[name="email"]').val();
    var $feedback_tag = $form.find(".feedback");
    var $loader = $form.find(".loading-icon");

    if (email) {
      $.ajax({
        url: ajax.ajaxurl,
        type: "post",
        data: {
          action: "newsletter_subscribe",
          form: $form.serialize(),
        },
        beforeSend: function () {
          $loader.removeClass("hidden");
          $feedback_tag.addClass("hidden");
        },
        success: function (result) {
          $loader.addClass("hidden");
          var response = JSON.parse(result);
          if (response.error == false) {
            $feedback_tag.html(
              '<span class="text-coifferieGray-700">' +
                strings.newsletter_success +
                "</span>"
            );
            $feedback_tag.removeClass("hidden");
          } else {
            $feedback_tag.html(
              '<span class="text-red-800">' +
                strings.newsletter_error +
                "</span>"
            );
            $feedback_tag.removeClass("hidden");
          }
        },
        error: function (xhr, status, error) {
          $loader.addClass("hidden");
          $feedback_tag.html(
            '<span class="text-red-800">' + strings.newsletter_error + "</span>"
          );
          $feedback_tag.removeClass("hidden");
        },
      });
    }
    return false;
  }

  function copyPromoCode() {
    // Récupérer le code promo à partir du texte du bouton
    var promoCode = $(this).text();

    // Créer un élément temporaire pour copier le texte
    var tempInput = $('<input>');
    $('body').append(tempInput);
    tempInput.val(promoCode).appendTo('body').select();
    document.execCommand("copy");
    tempInput.remove();

    // Afficher le message de confirmation
    $('#copyStatus').text("Code promo copié : " + promoCode);
    $('#copyStatus').delay(1000).fadeOut();
}

// Fonction pour afficher le popup
function showPopup() {
  $('.popup-overlay').fadeIn();
  $('.popup-container').fadeIn();
}

// Fonction pour cacher le popup
function hidePopup() {
  $('.popup-overlay').fadeOut();
  $('.popup-container').fadeOut();
}

})(jQuery);